let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4hEoh")).then(() => parcelRequire('6zTTo'));